import { WizardOptions } from '../utils/types';

export interface AppleWizardOptions extends WizardOptions {
  projectDir: string | undefined;
}
